import { render, staticRenderFns } from "./SunHeroHeader.vue?vue&type=template&id=145238c5&scoped=true"
import script from "./SunHeroHeader.vue?vue&type=script&lang=js"
export * from "./SunHeroHeader.vue?vue&type=script&lang=js"
import style0 from "./SunHeroHeader.vue?vue&type=style&index=0&id=145238c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145238c5",
  null
  
)

export default component.exports